import { isEmpty, findIndex } from 'lodash';
import { strings } from '../../assets/strings/all';

export const verifyCaseInputData = (caseData, fieldArray) => {
  const {
    cases: { errors: casesErrorStrings },
  } = strings;
  const errors = {};
  if (caseData.inquiryType === undefined || caseData.inquiryType === '') {
    errors['inquiryType'] = casesErrorStrings.type_required;
  }
  if (
    caseData.caseTitle === undefined ||
    (caseData.caseTitle && caseData.caseTitle.length < 8)
  ) {
    errors['caseTitle'] = casesErrorStrings.case_title_error;
  }
  console.log('from function errors ,', errors);
  Object.keys(fieldArray).forEach((field) => {
    const fieldData = fieldArray[field];
    const { type } = fieldData;

    let caseInputData = caseData[field];

    if (type === 'extra-details') {
      const caseInputDataIndex = findIndex(caseData.extraDetails, [
        'name',
        field,
      ]);

      if (caseInputDataIndex > -1)
        caseInputData = caseData['extraDetails'][caseInputDataIndex].value;
    }

    let isValidInput = !isEmpty(caseInputData);

    if (typeof caseInputData === 'string') {
      caseInputData = caseInputData.trim();
    } else if (typeof caseInputData === 'number') {
      isValidInput = caseInputData > 0;
    }

    delete errors[field];
    if (fieldData.isRequired && !isValidInput) {
      const error = `${fieldData.name} ${casesErrorStrings.is_required}`;
      errors[field] = error;
    }
  });
  if (caseData.inquiryType.slug === 'Case') {
    if (!caseData.race) {
      errors['race'] = casesErrorStrings.race_required;
    }
    if (
      caseData.patientAge === null ||
      caseData.patientAge === undefined ||
      caseData.patientAge === ''
    ) {
      errors['patientAge'] = casesErrorStrings.age_required;
    }
  }
  return errors;
};
